import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import { _100 } from "../../constants";
import { Fraction } from "./fraction";
var _100_PERCENT = new Fraction(_100);
export var Percent = /*#__PURE__*/ function(Fraction) {
    "use strict";
    _inherits(Percent, Fraction);
    var _super = _create_super(Percent);
    function Percent() {
        _class_call_check(this, Percent);
        return _super.apply(this, arguments);
    }
    var _proto = Percent.prototype;
    _proto.toSignificant = function toSignificant() {
        var significantDigits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5, format = arguments.length > 1 ? arguments[1] : void 0, rounding = arguments.length > 2 ? arguments[2] : void 0;
        return this.multiply(_100_PERCENT).toSignificant(significantDigits, format, rounding);
    };
    _proto.toFixed = function toFixed() {
        var decimalPlaces = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2, format = arguments.length > 1 ? arguments[1] : void 0, rounding = arguments.length > 2 ? arguments[2] : void 0;
        return this.multiply(_100_PERCENT).toFixed(decimalPlaces, format, rounding);
    };
    return Percent;
}(Fraction);
